import { Breadcrumb, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface IProps {
  items: Array<{
    path: string;
    title: string;
  }>;
  className?: string;
}

const CustomBreadcrumb = (props: IProps) => {
  return (
    <Row className={props.className}>
      <Col>
        <Breadcrumb>
          {props.items.map((item, index) => (
            <Breadcrumb.Item
              key={index}
              linkAs={Link}
              linkProps={{ to: item.path }}
              href={item.path}
              active={index === props.items.length - 1}
            >
              {item.title}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </Col>
    </Row>
  );
};

export default CustomBreadcrumb;
